import axios from "../config/axios"


export const LanguageRepository = {
  getAll: () => {
    return axios.get(`/api/language-support/all`);
  },
  getPaged: (page = 0, size = 10) => {
    return axios.get(`/api/language-support`, {params: {page, size}});
  },
  getById: (id) => {
    return axios.get(`/api/language-support/${id}`);
  },
  create: (language) => {
    return axios.post(`/api/language-support`, language);
  },
  edit: (id, language) => {
    return axios.put(`/api/language-support/${id}`, language);
  },
  delete: (id) => {
    return axios.delete(`/api/language-support/${id}`);
  },
}
